<sui-toolbar #tb>
  <sui-checkbox
    *ngIf="canSelectContent"
    [checked]="selectAllChecked"
    (checkedChange)="onSelectAllChange($event)"
    [suiTooltip]="selectAllTooltip"
  ></sui-checkbox>

  <!-- advanced quick-search self-dispatches in feed mode -->
  <app-advanced-quick-search
    *ngIf="canMassOps"
    [placeholder]="'feed-actions.placeholder.search' | translate"
    [value]="feedSearchQuery"
  ></app-advanced-quick-search>

  <sui-button
    variant="ghost"
    size="sm"
    [iconOnly]="true"
    [leadingIcon]="['fas', 'refresh']"
    [ariaLabel]="'feed-actions.button.refresh-tooltip' | translate"
    [suiTooltip]="'feed-actions.button.refresh-tooltip' | translate"
    (click)="onRefresh()"
  ></sui-button>

  <!-- Selected mass-ops (only when a selection exists) -->
  <ng-container *ngIf="hasSelectedPosts">
    <sui-button
      variant="ghost"
      [leadingIcon]="['fas', 'check-circle']"
      [trailingIcon]="['fas', 'caret-down']"
      [iconOnly]="tb.collapsed()"
      [ariaLabel]="tb.collapsed() ? selectedLabel : undefined"
      [suiTooltip]="tb.collapsed() ? selectedLabel : ''"
      [suiPopoverTrigger]="selectedPanel"
      suiPopoverPlacement="bottom-start"
      [suiPopoverContainer]="popoverContainer()"
      #selectedTrigger="suiPopoverTrigger"
      [expanded]="selectedTrigger.isOpen()"
    >
      {{
        tb.collapsed()
          ? selectedCount
          : selectedLabel + " (" + selectedCount + ")"
      }}
    </sui-button>
    <ng-template #selectedPanel>
      <div suiPopover class="dropdown-menu">
        <div class="dropdown-heading" *ngIf="tb.collapsed()">
          {{ selectedLabel }}
        </div>
        <ng-container *ngFor="let item of selectedItems">
          <div *ngIf="item.isSeparator" class="dropdown-divider"></div>
          <div *ngIf="item.isTitle" class="dropdown-heading">
            {{ item.text }}
          </div>
          <sui-checkbox
            *ngIf="!item.isSeparator && !item.isTitle && item.isToggle"
            class="dropdown-item"
            indicatorPosition="trailing"
            [checked]="showSelectedOnly"
            (checkedChange)="item.action?.()"
          >
            <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
            <span>{{ item.text }}</span>
          </sui-checkbox>
          <a
            *ngIf="!item.isSeparator && !item.isTitle && !item.isToggle"
            class="dropdown-item"
            (click)="
              item.action?.(); $event.preventDefault(); $event.stopPropagation()
            "
          >
            <span class="dropdown-item-link-col1">
              <span class="dropdown-item-link-label">
                <div *ngIf="item.icon">
                  <fa-icon [icon]="item.icon"></fa-icon>
                </div>
                <span>{{ item.text }}</span>
              </span>
            </span>
          </a>
        </ng-container>
      </div>
    </ng-template>
  </ng-container>

  <!-- Actions: feed-wide algorithms -->
  <ng-container *ngIf="canMassOps">
    <sui-button
      class="right-group-start"
      variant="ghost"
      [leadingIcon]="['fas', 'bars']"
      [trailingIcon]="['fas', 'caret-down']"
      [iconOnly]="tb.collapsed()"
      [ariaLabel]="tb.collapsed() ? actionsLabel : undefined"
      [suiTooltip]="
        tb.collapsed()
          ? actionsLabel
          : ('feed-actions.button.actions-tooltip' | translate)
      "
      [suiPopoverTrigger]="actionsPanel"
      suiPopoverPlacement="bottom-end"
      [suiPopoverContainer]="popoverContainer()"
      #actionsTrigger="suiPopoverTrigger"
      [expanded]="actionsTrigger.isOpen()"
    >
      {{ tb.collapsed() ? "" : actionsLabel }}
    </sui-button>
    <ng-template #actionsPanel>
      <div suiPopover class="dropdown-menu">
        <div class="dropdown-heading" *ngIf="tb.collapsed()">
          {{ actionsLabel }}
        </div>
        <ng-container *ngFor="let item of actionItems">
          <div *ngIf="item.isSeparator" class="dropdown-divider"></div>
          <div *ngIf="item.isTitle" class="dropdown-heading">
            {{ item.text }}
          </div>
          <a
            *ngIf="!item.isSeparator && !item.isTitle"
            class="dropdown-item"
            (click)="
              item.action?.(); $event.preventDefault(); $event.stopPropagation()
            "
          >
            <span class="dropdown-item-link-col1">
              <span class="dropdown-item-link-label">
                <div *ngIf="item.icon">
                  <fa-icon [icon]="item.icon"></fa-icon>
                </div>
                <span>{{ item.text }}</span>
              </span>
            </span>
            <span class="dropdown-item-link-col2">
              <button
                *ngIf="item.secondaryAction"
                type="button"
                class="dropdown-item-secondary-action"
                [title]="item.secondaryAction.tooltip || ''"
                (click)="
                  item.secondaryAction.action();
                  $event.preventDefault();
                  $event.stopPropagation()
                "
              >
                <fa-icon [icon]="item.secondaryAction.icon"></fa-icon>
              </button>
            </span>
          </a>
        </ng-container>
      </div>
    </ng-template>
  </ng-container>

  <!-- View -->
  <ng-container *ngIf="canView">
    <sui-button
      [class.right-group-start]="!canMassOps"
      variant="ghost"
      [leadingIcon]="['fas', 'eye']"
      [trailingIcon]="['fas', 'caret-down']"
      [iconOnly]="tb.collapsed()"
      [ariaLabel]="tb.collapsed() ? viewLabel : undefined"
      [suiTooltip]="
        tb.collapsed()
          ? viewLabel
          : ('feed-actions.button.view-tooltip' | translate)
      "
      [suiPopoverTrigger]="viewPanel"
      suiPopoverPlacement="bottom-end"
      [suiPopoverContainer]="popoverContainer()"
      #viewTrigger="suiPopoverTrigger"
      [expanded]="viewTrigger.isOpen()"
    >
      {{ tb.collapsed() ? "" : viewLabel }}
    </sui-button>
    <ng-template #viewPanel>
      <div suiPopover class="dropdown-menu view-dropdown-menu">
        <div class="dropdown-heading" *ngIf="tb.collapsed()">
          {{ viewLabel }}
        </div>
        <ng-container *ngFor="let group of viewGroups">
          <div
            *ngIf="group.radioGroup; else plainRows"
            sui-radio-group
            orientation="vertical"
            [ngModel]="group.value"
            [ngModelOptions]="{ standalone: true }"
            (valueChange)="onViewRadioChange(group, $event)"
          >
            <sui-radio
              *ngFor="let item of group.items"
              class="dropdown-item"
              indicatorPosition="trailing"
              [value]="item.value"
            >
              <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
              <span>{{ item.text }}</span>
            </sui-radio>
          </div>
          <ng-template #plainRows>
            <ng-container *ngFor="let item of group.items">
              <div *ngIf="item.isSeparator" class="dropdown-divider"></div>
              <div *ngIf="item.isTitle" class="dropdown-heading">
                {{ item.text }}
              </div>
              <sui-checkbox
                *ngIf="!item.isSeparator && !item.isTitle"
                class="dropdown-item"
                indicatorPosition="trailing"
                [checked]="!!item.isSelected"
                (checkedChange)="item.action?.()"
              >
                <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
                <span>{{ item.text }}</span>
              </sui-checkbox>
            </ng-container>
          </ng-template>
        </ng-container>
      </div>
    </ng-template>
  </ng-container>

  <!-- Sort -->
  <ng-container *ngIf="canSort">
    <sui-button
      [class.right-group-start]="!canMassOps && !canView"
      variant="ghost"
      [leadingIcon]="sortDirIcon"
      [trailingIcon]="['fas', 'caret-down']"
      [iconOnly]="tb.collapsed()"
      [ariaLabel]="tb.collapsed() ? sortLabel : undefined"
      [suiTooltip]="
        tb.collapsed()
          ? sortLabel
          : ('feed-actions.button.sort-tooltip' | translate)
      "
      [suiPopoverTrigger]="sortPanel"
      suiPopoverPlacement="bottom-end"
      [suiPopoverContainer]="popoverContainer()"
      #sortTrigger="suiPopoverTrigger"
      [expanded]="sortTrigger.isOpen()"
    >
      {{ tb.collapsed() ? "" : sortLabel }}
    </sui-button>
    <fa-icon
      *ngIf="sortFieldIcon"
      class="sort-field-icon"
      [icon]="sortFieldIcon"
    ></fa-icon>
    <ng-template #sortPanel>
      <div suiPopover class="dropdown-menu">
        <div class="dropdown-heading" *ngIf="tb.collapsed()">
          {{ sortLabel }}
        </div>
        <div
          sui-radio-group
          orientation="vertical"
          [ngModel]="sortField"
          [ngModelOptions]="{ standalone: true }"
          (valueChange)="onSortFieldChange($any($event))"
        >
          <sui-radio
            *ngFor="let item of sortFieldItems"
            class="dropdown-item"
            indicatorPosition="trailing"
            [value]="item.value"
          >
            <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
            <span>{{ item.text }}</span>
          </sui-radio>
        </div>
        <div class="dropdown-divider"></div>
        <div
          sui-radio-group
          orientation="vertical"
          [ngModel]="sortDirection"
          [ngModelOptions]="{ standalone: true }"
          (valueChange)="onSortOrderChange($any($event))"
        >
          <sui-radio
            *ngFor="let item of sortOrderItems"
            class="dropdown-item"
            indicatorPosition="trailing"
            [value]="item.value"
          >
            <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
            <span>{{ item.text }}</span>
          </sui-radio>
        </div>
      </div>
    </ng-template>
  </ng-container>
</sui-toolbar>
